import PropTypes from 'prop-types';
import { linksShape } from './sharedShapes';

export default PropTypes.shape({
  active: PropTypes.bool,
  amount: PropTypes.number,
  approved_at: PropTypes.string,
  blocked_at: PropTypes.string,
  budget: PropTypes.number,
  commission: PropTypes.number,
  currency: PropTypes.oneOf(['eur', 'gbp', 'usd']),
  day_rate: PropTypes.bool,
  deleted_at: PropTypes.string,
  external: PropTypes.bool,
  external_url: PropTypes.string,
  expires_at: PropTypes.string,
  featured: PropTypes.bool,
  id: PropTypes.number,
  invites: PropTypes.shape({ invites: PropTypes.array }),
  links: linksShape,
  location: PropTypes.string,
  num_of_approved_pitches_and_not_accepted: PropTypes.number,
  num_of_pitches: PropTypes.number,
  num_of_pitches_or_pending_pitches: PropTypes.number,
  num_of_public_questions: PropTypes.number,
  priority: PropTypes.string,
  private: PropTypes.bool,
  questions: PropTypes.array,
  rating: PropTypes.array,
  remote: PropTypes.bool,
  role: PropTypes.string,
  roles: PropTypes.array,
  skill: PropTypes.string,
  spec: PropTypes.string,
  status: PropTypes.string,
  text: PropTypes.string,
  timestamp: PropTypes.string,
  user: PropTypes.number,
  user_id: PropTypes.number,
  voucher_id: PropTypes.number,
});
